import type { Notification } from "@kontextwerk/control-web-client"

export const isOpenNotificationStatus = (status: unknown): boolean => {
  const normalized = String(status ?? "OPEN")
    .trim()
    .toUpperCase()

  return !normalized || normalized === "OPEN"
}

const payloadObject = (candidate: Notification): Record<string, unknown> =>
  candidate?.payload && typeof candidate.payload === "object"
    ? (candidate.payload as Record<string, unknown>)
    : {}

export const inboxCaseActionCaseIds = (candidate: Notification): string[] => {
  const ids: string[] = []
  for (const item of candidate.items) {
    if (item.item_kind !== "ACTION_CASE") continue

    const id = item.action_case_id?.trim() ?? ""

    if (id && !ids.includes(id)) ids.push(id)
  }

  return ids
}

export const inboxCaseWorkflowActionCaseIds = inboxCaseActionCaseIds

export const hasInboxCaseWorkflowTodo = (candidate: Notification): boolean => {
  const payload = payloadObject(candidate)
  const hasInboxCase = inboxCaseWorkflowActionCaseIds(candidate).length > 0

  return hasInboxCase && typeof payload.flow_key === "string" && payload.flow_key.trim().length > 0
}

export const isActionableInboxCaseTodo = (candidate: Notification): boolean => {
  const hasOpenWorkflow = candidate.items.some(
    (item) =>
      item.item_kind === "ACTION_CASE" &&
      (item.action_case_status === "open" || item.action_case_status === "in_progress"),
  )

  if (!hasOpenWorkflow && !isOpenNotificationStatus(candidate?.status)) return false

  return inboxCaseActionCaseIds(candidate).length > 0 && hasInboxCaseWorkflowTodo(candidate)
}
